import Vue from 'vue'
const utilsBase = `./components/utils/`
const ActionButton = () => import(`${utilsBase}ActionButton.vue`)
const Button = () => import(`${utilsBase}Button.vue`)
const VodPlayer = () => import(`${utilsBase}VodPlayer.vue`)
const CheckBox = () => import(`${utilsBase}CheckBox.vue`)
const LoginTextInput = () => import(`${utilsBase}LoginTextInput.vue`)
const ListLoader = () => import(`${utilsBase}ListLoader.vue`)
const ListPlaceholder = () => import(`${utilsBase}ListPlaceholder.vue`)
const Modal = () => import(`${utilsBase}Modal.vue`)
const FeatureNavigation = () => import(`${utilsBase}FeatureNavigation`)
const EditSection = () => import(`./components/forms/EditSection`)
const Emoji = () => import(`${utilsBase}Emoji`)
const WarningPopup = () => import(`${utilsBase}WarningPopup`)
const List = () => import(`${utilsBase}List`)
const RegularList = () => import(`${utilsBase}RegularList`)
const vimg = () => import(`${utilsBase}v-img.vue`)
import VueYouTubeEmbed from 'vue-youtube-embed'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueClipboard from 'vue-clipboard2'

export default function setGlobalComponents() {
    Vue.component('ActionButton', ActionButton)
    Vue.component('Button', Button)
    Vue.component('CheckBox', CheckBox)
    Vue.component('LoginTextInput', LoginTextInput)
    Vue.component('ListPlaceholder', ListPlaceholder)
    Vue.component('Modal', Modal)
    Vue.component('FeatureNavigation', FeatureNavigation)
    Vue.component('EditSection', EditSection)
    Vue.component('ListLoader', ListLoader)
    Vue.component('Emoji', Emoji)
    Vue.component('WarningPopup', WarningPopup)
    Vue.component('List', List)
    Vue.component('RegularList', RegularList)
    Vue.component('VodPlayer', VodPlayer)
    Vue.component('v-img', vimg)
    Vue.use(VueYouTubeEmbed)
    Vue.use(VueClipboard)
    Vue.use(vueVimeoPlayer)
}
